/***
 *
 *   PRACTICE AREA TAGS
 *   Renders up to MAX_VISIBLE_TAGS practice area pills with an overflow "+N" count.
 *
 *   PROPS
 *   areas: string[]
 *
 ***/

import Style from './practice-area-tags.tailwind.js';
import { MAX_VISIBLE_TAGS } from './practice-area-tags.constants.js';

export function PracticeAreaTags({ areas }) {
  if (!areas?.length) return <span className={Style.empty}>—</span>;

  const visible = areas.slice(0, MAX_VISIBLE_TAGS);
  const overflow = areas.length - visible.length;

  return (
    <div className={Style.container}>
      {visible.map(a => (
        <span key={a} className={Style.tag}>{a}</span>
      ))}
      {overflow > 0 && (
        <span className={Style.overflow}>+{overflow}</span>
      )}
    </div>
  );
}
